import Modal from 'components/Modal/Modal'
import { t } from 'i18next'
import { useState } from 'react'
import { Box, CircularProgress, Stack, Typography } from '@mui/material'
import { useGetMasterProducts } from 'hooks/useProducts'
import { MasterProduct } from 'types/api/product'
import { ProductCard } from './ProductCard'
import { RelatedProductsSearch } from './RelatedProductsSearch'

type Props = {
  modal: { right: boolean }
  handleCloseModal: () => void
  handleAddProduct: (obj: {
    gtin: string
    referencedTradeItemTypeCode: string
  }) => void
  title: string
  referencedTradeItemTypeCode: string
}

export const AddRelatedProductModal = ({
  modal,
  handleCloseModal,
  handleAddProduct,
  title,
  referencedTradeItemTypeCode,
}: Props) => {
  const [input, setInput] = useState<string>('')
  const [query, setQuery] = useState<string | undefined>(undefined)
  const [queryKey, setQueryKey] = useState<string | undefined>(undefined)
  const { isFetching, products } = useGetMasterProducts(
    1,
    100,
    query,
    queryKey,
    true
  )

  const handleSearch = (key: string, queryString: string | undefined) => {
    setQuery(queryString)
    setQueryKey(key)
  }

  const handleClose = () => {
    handleCloseModal()
    setQuery(undefined)
    setInput('')
  }

  return (
    <Modal
      showButton={false}
      setModal={handleClose}
      modal={modal}
      title={title}>
      <RelatedProductsSearch
        input={input}
        setInput={setInput}
        placeholderText={t('products.searchProductsPlaceholder')}
        handleClick={handleSearch}
        query={query}
        setQuery={setQuery}
      />
      {isFetching ? (
        <Box display='flex' justifyContent='center'>
          <CircularProgress />
        </Box>
      ) : (
        <Stack>
          {query &&
            query.length > 0 &&
            products.map((product: MasterProduct) => (
              <ProductCard
                key={product.id}
                product={product}
                handleAddProduct={handleAddProduct}
                referencedTradeItemTypeCode={referencedTradeItemTypeCode}
              />
            ))}
          {query &&
            query.length > 0 &&
            (!products || products?.length === 0) && (
              <Typography ml={2}>{t('noSearchResultWithQuery')}</Typography>
            )}
        </Stack>
      )}
    </Modal>
  )
}
